"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPath = void 0;
var formatPathObject = function (_a) {
    var pathname = _a.pathname, search = _a.search, hash = _a.hash;
    return "".concat(pathname || '').concat(search || '').concat(hash || '');
};
var formatPath = function (to) {
    return typeof to === 'string' ? to : formatPathObject(to);
};
exports.formatPath = formatPath;
